import { lumi } from '@/lib/lumi'

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&')
    .replace(/</g, '<')
    .replace(/>/g, '>')
    .replace(/"/g, '&quot;')
}

function markdownToSafeHtml(markdown: string): string {
  const lines = markdown.split('\n').map((line) => {
    const trimmed = line.trim()
    if (!trimmed) return ''
    if (trimmed.startsWith('# ')) {
      return `<h1>${escapeHtml(trimmed.slice(2))}</h1>`
    }
    if (trimmed.startsWith('- ')) {
      const inner = escapeHtml(trimmed.slice(2)).replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      return `<li>${inner}</li>`
    }
    return `<p>${escapeHtml(trimmed).replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')}</p>`
  }).filter(Boolean)

  const grouped: string[] = []
  let buffer: string[] = []
  const flush = () => {
    if (buffer.length === 0) return
    grouped.push(`<ul>${buffer.join('')}</ul>`)
    buffer = []
  }
  for (const line of lines) {
    if (line.startsWith('<li>')) {
      buffer.push(line)
    }
    else {
      flush()
      grouped.push(line)
    }
  }
  flush()
  return grouped.join('')
}

export async function sendStepByStepSolution(title: string, markdown: string) {
  const user = lumi.auth.user
  const email = user?.email
  if (!email) {
    throw new Error('Sign in to email this step-by-step solution to your student inbox.')
  }

  const safeTitle = escapeHtml(title)
  const bodyHtml = markdownToSafeHtml(markdown)

  await lumi.tools.email.send({
    to: email,
    subject: `FunMathCalculator: ${title}`,
    fromName: 'FunMathCalculator',
    html: `<h1>${safeTitle}</h1><p>Here is your step-by-step solution from FunMathCalculator.</p>${bodyHtml}<p>Keep this walkthrough for homework, class, or later review.</p>`,
  })
}
